import taskInstancesUrl from './taskInstances.html';

class TaskInstancesCtrl {
  constructor(
    AlertService,
    ShiftTasksService,
    ShiftTasksTabsService,
    SlingApi,
    Utils,
    $rootScope,
    $state,
    $location,
    $scope,
    $stateParams
  ) {
    'ngInject';

    Object.assign(this, {
      AlertService,
      ShiftTasksService,
      ShiftTasksTabsService,
      SlingApi,
      Utils,
      $rootScope,
      $state,
      $location,
      $scope,
      $stateParams,
    });
  }

  $onInit() {
    const { date } = this.$stateParams;
    if (date) {
      this.ShiftTasksService.setReferenceDate(this.Utils.getRealDate(date));
    }

    this.rangeWatcher = this.$scope.$watch('ctrl.range', () => {
      const dateString = this.Utils.formatDate(this.ShiftTasksService.date);
      if (dateString !== this.$stateParams.date) {
        this.$location.search('date', dateString);
      }
      this.reload();
    });
    this.cacheClearedWatcher = this.$rootScope.$on('shiftTasks:cache:cleared', this.reload);
    this.shouldDisplayTabs = this.ShiftTasksTabsService.shouldDisplayTabs();
  }

  $onDestroy() {
    this.rangeWatcher();
    this.cacheClearedWatcher();
  }

  reload = async () => {
    if (!this.canDisplayContent) {
      return;
    }

    try {
      this.areInstancesLoading = true;
      await this.ShiftTasksService.loadTaskInstances();
      this.areInstancesLoading = false;
    } catch (e) {
      this.areInstancesLoading = false;
    }
  };

  get range() {
    return this.ShiftTasksService.range;
  }

  get canDisplayContent() {
    return this.ShiftTasksService.isFeatureEnabled;
  }
}

export default {
  templateUrl: taskInstancesUrl,
  controller: TaskInstancesCtrl,
  controllerAs: 'ctrl',
};
